import React from "react"
import { usePopulateStateWithQParams } from "../utils/queryParameters"

interface QueryParameterContextProps {
  children?: React.ReactNode
}

const QueryParameterContext: React.FC<QueryParameterContextProps> = ({
  children,
}) => {
  usePopulateStateWithQParams()
  return <>{children}</>
}

export default QueryParameterContext
